import PerfectScrollbar from "perfect-scrollbar";
import {Lightbox} from "../../classes/Lightbox";



export const initSectionContacts = () => {
    const component = document.querySelector(`section.contacts`);

    if ( component )
    {
        const officesList = component.querySelector(`div.offices aside ul`);
		let ps = null;

		const togglePerfectScrollbar = () => {
			if ( window.innerWidth < 956 && ps )
			{
				ps.destroy();
				ps = null;	
			}
		
			if ( window.innerWidth >= 956 && !ps )
			{
				ps = new PerfectScrollbar(officesList.parentElement, {
					wheelPropagation: false,
				});
			}	

			if ( ps )
			{
				ps.update();
			}
		};

        const showCurrent = (current) => {
            officesList.classList.add(`show-office`);
            current.classList.add(`current`); 
            togglePerfectScrollbar();
        };

        const hideCurrent = () => {
            officesList.classList.remove(`show-office`);
            officesList.querySelector(`li.current`).classList.remove(`current`); 
			
			if (officesList.querySelector(`li.animated`))
			{
				officesList.querySelector(`li.animated`).classList.remove(`animated`); 
			}
            togglePerfectScrollbar();
        };

        officesList.addEventListener(`click`, ({target}) => {
            if ( !target.closest(`li.head`) )
            {
                const listItem = target.closest(`li`);
                
                if ( window.innerWidth < 956 )
                {
                    Lightbox.open(listItem.innerHTML, null, `tooltip`);
                } 
				else
                {
                    const isCurrent = listItem.classList.contains(`current`);
                    const buttonBack = target.closest(`button.back`);
    
                    if ( !isCurrent )
                    {
                        showCurrent(target.closest(`li`));
                    }
    
                    if ( buttonBack && isCurrent )
                    {
                        hideCurrent();
                    } 
                }
            }
        });

        window.addEventListener(`resize`, () => {
            if ( window.innerWidth < 956 && officesList.classList.contains(`show-office`) )
            {
                hideCurrent();
            }

			togglePerfectScrollbar();
        });

		togglePerfectScrollbar();
    }
};